const translateValue = (value, t) => (typeof value === 'string' ? t(value) : value);

export const translateRouteConfig = (route, t) => {
	if (!route || typeof route !== 'object') {
		return route;
	}

	const translatedChildren = route.children && typeof route.children === 'object'
		? Object.keys(route.children).reduce((acc, key) => {
			acc[key] = translateRouteConfig(route.children[key], t);
			return acc;
		}, {})
		: route.children;

	return {
		...route,
		title: translateValue(route.title, t),
		head: route.head
			? {
				...route.head,
				title: translateValue(route.head.title, t),
				description: translateValue(route.head.description, t),
			}
			: route.head,
		layoutProps: route.layoutProps
			? {
				...route.layoutProps,
				title: translateValue(route.layoutProps.title, t),
			}
			: route.layoutProps,
		children: translatedChildren,
	};
};

export const translateRoutesConfig = (routes, t) => {
	if (!routes || typeof routes !== 'object') {
		return routes;
	}

	return Object.keys(routes).reduce((acc, routeKey) => {
		acc[routeKey] = translateRouteConfig(routes[routeKey], t);
		return acc;
	}, {});
};
